import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { _Config, SingleConfigGQL } from 'src/graphql/generated';

@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: []
})
export class HelpdeskComponent implements OnInit {
  data$: Observable<_Config> 
  constructor(
    private configService: SingleConfigGQL
  ) { 
    this.data$ = this.configService.fetch({ id: 'HELPDESK'}).pipe(map(d => d.data._config[0] as _Config))
  }

  ngOnInit(): void {

  }

}
